import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"

import HeadCSS from "../components/headCss"
import SEOhead from "../components/seo.js"

import PageTemplate from "../templates/page"

const IndexPage = ({data}) => {
	return(
		<PageTemplate data={data}/>
	) 
}

export default IndexPage

export const Head = ({data}) => {
	return ( 
		<>
			<SEOhead data={data.wpPage.seo} customJsonLD={data.wpPage.customJsonLD}/>
			<HeadCSS data={data} />
		</>
	)
}

export const query = graphql`
	query WpFrontPage {
		wpPage(isFrontPage: {eq: true}) {
			content
			databaseId
			elementorCss
			elementorData
			template {
				templateName
			}
			title
			customJsonLD
			seo {
				metaDesc
				metaRobotsNofollow
				metaRobotsNoindex
				opengraphUrl
				opengraphType
				opengraphAuthor
				opengraphDescription
				opengraphImage {
					localFile {
						publicURL
					}
				}
				opengraphTitle
				title
				twitterDescription
				twitterTitle
				schema {
					raw
				}
			}
		}
		wp {
			elementorCssKit
			elementorHF
		}
	}`